import { Modal } from "antd";
// import axios from "axios";
// import { authHeader } from "../utils/utils";
// import { UrlConstants } from "../utils/ApiConstants";
import { Notification } from "../components/notification/notification";
import { PostRequest, PutRequest } from "../utils/api";

const { confirm } = Modal;

const showConfirm = (recordIds: string[], endpoint: string, message: string, callBack: any = null) => {
    if (recordIds === undefined || recordIds === null || recordIds.length === 0) {
        alert("Please choose atleast one record.");
        return;
    }
    confirm({
        title: message,
        okText: "Yes",
        cancelText: "No",
        onOk() {
            performBulkApproveOrReject(recordIds, endpoint, callBack);
        },
        onCancel() { },
    });
};

const performBulkApproveOrReject: any = async (recordIds: string[], endpoint: string, callBack: any) => {
    if (recordIds.length === 0) {
        return { message: "There are no record(s) selected for approval.", status: "SUCCESS" };
    }

    endpoint = endpoint?.replace("{recordIds}", recordIds.join(","));
    //const endpoint = "loan/bulk/platform/api/assignment-to-tc/pending-verifications/" + recordIds.join(",") + "/" + operation;
    try {
        // await axios.post(`${UrlConstants.BASE_URL}${replaceWithCurrentApiVersion(endpoint)}`, {}, {
        //     headers: {
        //         authorization: `${authHeader().Authorization}`,
        //         "Access-Control-Allow-Origin": "*",
        //     },
        // });

        await PostRequest(endpoint, {});
        // let errors = data?.records.filter((record: { status: string; }) => record.status === "ERROR").map((record: { message: string; }) => record.message);
        // if (errors && errors.length > 0) {
        // Notification("error", "Failed to mark the status for below records: " + errors);
        // return {message:"Failed to mark the status for below records: " + errors, status:"ERROR"};
        // } else {
        Notification("success", "Status marked successfully.");
        if (callBack) callBack();
        return { message: "Status marked successfully. ", status: "SUCCESS" };
        // }
    } catch (err: any) {
        Notification("error", "Something went wrong, please check with admin.");
        return { message: "Something went wrong, please check with admin.", status: "ERROR" };
    }
}

const updateApproveOrRejectRecord: any = async (recordId: string, endpoint: string, formData: any) => {
    endpoint = endpoint?.replace("{recordId}", recordId);
    try {
        await PutRequest(endpoint, formData);

        Notification("success", "Status marked successfully.");
        return { message: "Status marked successfully. ", status: "SUCCESS" };

    } catch (err: any) {
        Notification("error", err?.response?.data?.message ?? "Something went wrong, please check with admin.");
        return { message: "Something went wrong, please check with admin.", status: "ERROR" };
    }
}

export const approvePendingVerificationRecords: any = (selectedRows: any[], args: any[], callBack = null) => {
    let recordIds = selectedRows.map(selectedRow => selectedRow["id"]);
    showConfirm(recordIds, args[0], "Do you want  approve " + recordIds.length + " record(s) ?", callBack);
}

export const rejectPendingVerificationRecords: any = (selectedRows: any[], args: any[], callBack = null) => {
    let recordIds = selectedRows.map(selectedRow => selectedRow["id"]);
    showConfirm(recordIds, args[0], "Do you want reject " + recordIds.length + " record(s) ?", callBack);
}

export const approveOrRejectPendingVerificationRecord: any = (recordId: string, data: any, args: any[]) => {
    return performBulkApproveOrReject([recordId], args[0]);
}
export const approveOrRejectRepoChargesRecord: any = (recordId: string, data: any, args: any[]) => {
    return updateApproveOrRejectRecord(recordId, args[0], data);
}

export const acceptRejectOrCancelVendorInvoice: any = async (recordId: string, data: any, args: any[], urlparams: Map<string, string>) => {
    let endpoint = args[0]?.replace("{recordId}", recordId);
    try {
        // await axios.post(`${UrlConstants.BASE_URL}${replaceWithCurrentApiVersion(endpoint)}`, data, {
        //     headers: {
        //         authorization: `${authHeader().Authorization}`,
        //         "Access-Control-Allow-Origin": "*",
        //     },
        // });

        await PostRequest(endpoint, data);

        Notification("success", `Invoice successfully marked as :${args[1]}`);
        return { message: `Invoice successfully marked as :${args[1]}`, status: "SUCCESS" };

    } catch (err: any) {
        Notification("error", err?.response?.data?.message ?? "Something went wrong, please check with admin.");
        return { message: "Something went wrong, please check with admin.", status: "ERROR" };
    }
}

export const regenerateVendorInvoice: any = async (recordId: string, data: any, args: any[], urlparams: Map<string, string>) => {
    let endpoint = args[0]?.replace("{recordId}", recordId);
    let payload = { capsId: urlparams.get("capsId"), profileCode: urlparams.get("profileCode"), recordContextId: urlparams.get("recordId"), monthYear: urlparams.get("monthYear") };
    try {
        // await axios.post(`${UrlConstants.BASE_URL}${replaceWithCurrentApiVersion(endpoint)}`, payload, {
        //     headers: {
        //         authorization: `${authHeader().Authorization}`,
        //         "Access-Control-Allow-Origin": "*",
        //     },
        // });

        await PostRequest(endpoint, payload);

        Notification("success", `Invoice successfully generated`);
        return { message: `Invoice successfully generated`, status: "SUCCESS" };

    } catch (err: any) {
        Notification("error", err?.response?.data?.message ?? "Something went wrong, please check with admin.");
        return { message: "Something went wrong, please check with admin.", status: "ERROR" };
    }
};

export const markStatusOfEntityWithPayload = async (recordId: string, data: any, args: any[], callBack: any) => {
    let endpoint = args[0];
    endpoint = endpoint?.replace("{recordId}", recordId);

    // adding extra fields info if required
    const requestBody = { ...data, ...args[1] };

    try {


        if (args[2] && args[2] === 'POST') {

            // await axios.post(`${UrlConstants.BASE_URL}${replaceWithCurrentApiVersion(endpoint)}`, requestBody, {
            //     headers: {
            //         authorization: `${authHeader().Authorization}`,
            //         "Access-Control-Allow-Origin": "*",
            //     },
            // })

            await PostRequest(endpoint, requestBody);

        } else {
            // await axios.put(`${UrlConstants.BASE_URL}${replaceWithCurrentApiVersion(endpoint)}`, requestBody, {
            //     headers: {
            //         authorization: `${authHeader().Authorization}`,
            //         "Access-Control-Allow-Origin": "*",
            //     },
            // })

            PutRequest(endpoint, requestBody);
        }

        Notification("success", "Status marked successfully.");
        if (callBack) callBack();
        return { message: "Status marked successfully. ", status: "SUCCESS" };
    } catch (err: any) {
        throw err.response?.data ?? err;
    }
}